
import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TokenInterceptor } from "app/authorized-http.service";
import { Observable } from "rxjs";
import {  Response } from '@angular/http';
import { UserListResource } from "app/resources/user/user-list-resource";
import { UtilsService } from "app/services/utils.service";
import { UserResource } from "app/resources/user/user-resource";
import { HttpClient } from "@angular/common/http";
import { environment } from "app/baseUrl";
import { KioskResource } from 'app/models/KioskResource';

@Injectable()
export class UserListService {

  constructor(private http: HttpClient, private httpa: TokenInterceptor, private utilsService: UtilsService) { }

  getUserList(url, body): Observable<UserListResource> {
    return this.http.post<UserListResource>(environment.url + url, body)
  }

  post(url, body): any {
    return this.http.post<UserResource>(environment.url + url, body)
  }

  
  get(url): Observable<KioskResource> {
    return this.http.get<KioskResource>(environment['url'] + url)
  }

}
